module.exports = __webpack_public_path__ + "static/media/card-icon.9e739cc4.svg";